import { apiHelpers } from '../utils/api';
import {
  Expense,
  CreateExpenseData,
  UpdateExpenseData,
  ExpensesResponse,
  ExpenseFilters,
} from '../types/expense';

export const expenseService = {
  async getExpenses(filters: ExpenseFilters = {}): Promise<ExpensesResponse> {
    const params = new URLSearchParams();

    if (filters.search) params.append('search', filters.search);
    if (filters.vendorId) params.append('vendorId', filters.vendorId);
    if (filters.status) params.append('status', filters.status);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));

    return await apiHelpers.get(`/expenses?${params.toString()}`);
  },

  async getExpense(id: string): Promise<Expense> {
    return await apiHelpers.get(`/expenses/${id}`);
  },

  async createExpense(data: CreateExpenseData): Promise<Expense> {
    return await apiHelpers.post('/expenses', data);
  },

  async updateExpense(id: string, data: UpdateExpenseData): Promise<Expense> {
    return await apiHelpers.put(`/expenses/${id}`, data);
  },

  async deleteExpense(id: string): Promise<void> {
    return await apiHelpers.delete(`/expenses/${id}`);
  },

  formatPaymentMethod(method: string): string {
    const methodMap: Record<string, string> = {
      cash: 'Cash',
      bank_transfer: 'Bank Transfer',
      credit_card: 'Credit Card',
      debit_card: 'Debit Card',
      check: 'Check',
      other: 'Other',
    };
    return methodMap[method] || method;
  },

  validateExpenseData(data: CreateExpenseData): string[] {
    const errors: string[] = [];

    if (!data.amount || data.amount <= 0) {
      errors.push('Expense amount must be greater than 0');
    }
    if (!data.expenseAccountId) {
      errors.push('An expense account is required');
    }
    if (!data.bankAccountId) {
      errors.push('A paid-from bank account is required');
    }

    return errors;
  },
};
